import Cookies from "js-cookie";

const TOKEN_OPTIONS = {
  sameSite: "Strict" as const,
  path: "/",
  expires: 8 / 24, // 8 hours
};

export const setAuthCookies = (NGAT: string, NGUID: string) => {
  try {
    Cookies.set("NGAT", NGAT, TOKEN_OPTIONS);
    Cookies.set("NGUID", NGUID, TOKEN_OPTIONS);
  } catch (error) {
    console.error("Failed to set auth cookies:", error);
    throw new Error("Unable to set authentication cookies");
  }
};

export const clearCookies = () => {
  try {
    Cookies.remove("NGAT", { path: "/" });
    Cookies.remove("idToken", { path: "/" });
    Cookies.remove("refreshToken", { path: "/" });
    Cookies.remove("NGUID", { path: "/" });
    Cookies.remove("bulkEnquiryIntent", { path: "/" });
    Cookies.remove("deviceFingerprint", { path: "/" });
    Cookies.remove("pendingCatalogFingerprints", { path: "/" });
  } catch (error) {
    console.error("Failed to clear auth cookies:", error);
  }
};

export const getAccessToken = () => Cookies.get("NGAT") || "";
export const getUserId = () => Cookies.get("NGUID") || "";
